import { BaseEditModel } from "model/BaseEditModel";
import GrupoUsuarios from "./GrupoUsuarios";
import Usuario from "./Usuario";

export default class GrupoUsuariosUsuario implements BaseEditModel {
    id: number;
    key: string | null = "";
    sequencial: number | null = 0;
    usuario: Usuario | null = null;
    grupo: GrupoUsuarios | null = null;
    constructor(
        id: number = 0,
        usuario: Usuario | null = null,
        grupo: GrupoUsuarios | null = null
    ) {
        this.id = id;
        this.usuario = usuario;
        this.grupo = grupo;
    }
    
}